// extracted by mini-css-extract-plugin
export var copyIcon = "_xc-2";
export var discountCard = "_xc-0";
export var discountCode = "_xc-3";
export var discountContent = "_xc-1";
export var loadingCard = "_xc-4";